import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Typography } from '@mui/material'

import { ConnectedStepsModal } from './steps-connections-modal.component'
import { useStyles } from 'src/components/impacts-library/impacts-library-list/styles'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { CountChip } from 'src/components/count-chip'
import { useAccountStepsConnections } from 'src/hooks'
import { useParams } from 'react-router-dom'
import { useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

const ConnectedStepsButton = () => {
  const [t] = useTranslation()
  const [open, setOpen] = useState(false)
  const classes = useStyles()
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  const { data, isLoading, refetch } = useAccountStepsConnections({})
  const [count, setCount] = useState<null | number>(null)
  const [activeCount, setActiveCount] = useState<null | number>(null)

  useEffect(() => {
    if (!isLoading && data?.data) {
      const pendingCount = data?.data.filter(
        (item) => !item.account_approved && !item.account_disconnected,
      )
      setCount(pendingCount.length)

      const activeCount = data?.data.filter(
        (item) => item.account_approved && !item.account_disconnected,
      )

      setActiveCount(activeCount.length)
    }
  }, [isLoading, data?.data])

  useEffect(() => {
    queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT_STEPS_CONNECTION, accountId])
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <Box sx={{ mb: '20px', display: 'flex', alignItems: 'center' }}>
        <Button
          type="button"
          onClick={handleOpen}
          variant="contained"
          color="secondary"
          className={`${classes.impactsLibraryButton}`}
        >
          <HelperWrapper t="connected-steps-button-text" isColorInherited />
          {activeCount && activeCount > 0 ? (
            <Typography sx={{ fontSize: 'inherit', ml: '5px' }}>({activeCount})</Typography>
          ) : null}
        </Button>
        <CountChip
          count={count}
          isLoading={isLoading}
          hoverText={t('connected-step-unapproved-notification-hover-popup.v')}
        />
      </Box>
      <ConnectedStepsModal handleClose={handleClose} open={open} />
    </>
  )
}

export { ConnectedStepsButton }
